import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { useFormattedData } from '../../hooks/useFormattedData';
import { getSummaryText } from './utils';

interface AvoidCrossCategoryComparisonsCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const AvoidCrossCategoryComparisonsCard: React.FC<AvoidCrossCategoryComparisonsCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Get formatted categories and subcategories (hooks must be called before any returns)
  const categories = useFormattedData('category');
  const subCategories = useFormattedData('sub-category');

  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'AvoidCrossCategoryComparisons') {
    return null;
  }

  const { comparisonType, target } = guideline.parameters;

  // Select the appropriate data based on comparison type
  const formattedData = comparisonType === 'category' ? categories : subCategories;

  // Find the matching category/subcategory by ID to get its name
  const targetItem = formattedData.find((item) => item.id === target);
  const targetName = targetItem?.label || target;

  const summaryText = getSummaryText(guideline, { targetName });

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Avoid Cross Category or Subcategory Comparisons"
      onEditClick={onEditClick}
    />
  );
};
